import { Component, Input } from '@angular/core';
import { ContentMission } from '../../../../models/search-results';

@Component({
    selector: 'app-mission-result',
    templateUrl: './mission-result.component.html',
    styleUrls: ['./mission-result.component.scss'],
    standalone: false
})
export class MissionResultComponent {
    @Input() mission: ContentMission;
}
